exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-nav[data-v-7f0090c8]{background:#fff;margin-bottom:15px}.content-nav a[data-v-7f0090c8],.content-nav span[data-v-7f0090c8]{float:left;width:16.66666666%;text-align:center;line-height:60px;border-bottom:4px solid #fefefe;font-size:16px;color:#666;padding-top:4px;cursor:pointer}.content-nav a[data-v-7f0090c8]:hover,.content-nav span[data-v-7f0090c8]:hover{color:#e03a3c}.content-nav a.grey[data-v-7f0090c8],.content-nav span.grey[data-v-7f0090c8]{color:#ccc;cursor:default}.content-nav a.nuxt-link-active[data-v-7f0090c8],.content-nav span.nuxt-link-active[data-v-7f0090c8]{border-color:#e03a3c}", ""]);

// exports
